import { FieldControllerProps } from '@dreryk/react-common';
import { FormController } from '@dreryk/react-components';

type HealthcareIdFormControllerProps = FieldControllerProps<'id', number>;

export const HealthcareIdFormController = (props: HealthcareIdFormControllerProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
      maxLength: 255,
   });

   return <FormController controller={controller} />;
};
